module.exports = __webpack_public_path__ + "static/media/copy.70b5d1f1.svg";